const moduleName = 'INSPECTIONS_ACTIONS';

const INSPECTIONS_ACTIONS = {
    CHANGE_STATE: `${moduleName}_CHANGE_STATE`,
    CHANGE_PAGE_NEXT: `${moduleName}_CHANGE_PAGE_NEXT`,
    CHANGE_PAGE_BACK: `${moduleName}_CHANGE_PAGE_BACK`,
    LOAD: `${moduleName}_LOAD`,
    LOAD_OK: `${moduleName}_LOAD_OK`,
    LOAD_ERROR: `${moduleName}_LOAD_ERROR`,
    LOAD_DETAIL: `${moduleName}_LOAD_DETAIL`,
    LOAD_DETAIL_OK: `${moduleName}_LOAD_DETAIL_OK`,
    LOAD_DETAIL_ERROR: `${moduleName}_LOAD_DETAIL_ERROR`,
    LOAD_CUSTOMER_OK: `${moduleName}_LOAD_CUSTOMER_OK`,
    LOAD_CUSTOMER_ERROR: `${moduleName}_LOAD_CUSTOMER_ERROR`,
    LOAD_STATE_OK: `${moduleName}_LOAD_STATE_OK`,
    LOAD_STATE_ERROR: `${moduleName}_LOAD_STATE_ERROR`,
    RESET_VALUES: `${moduleName}_RESET_VALUES`,
};
export default INSPECTIONS_ACTIONS;



// WEBPACK FOOTER //
// ./src/constants/actions/inspections.js